import Alert from "@pathwright/ui/src/components/alert/Alert"
import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Card from "@pathwright/ui/src/components/card/Card"
import CardHeader from "@pathwright/ui/src/components/card/CardHeader"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import LoadingCircle from "@pathwright/ui/src/components/loading/LoadingCircle"
import styled from "styled-components"
import { useGroupQuery } from "../api/generated"
import { getGroupUrl, getStepUrl } from "../utils/urls"
import useOrderPollingQuery, {
  useOnOrderFullfiled
} from "./useOrderPollingQuery"

const NarrowCard = styled(Card)`
  & > .View {
    max-width: 500px;
  }
`

const CenteredContent = styled.div`
  padding: 40px 25px;
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
`

export const RegistrationOrderConfirmation = ({
  orderId,
  cohortId,
  onOrderFulfilled
}) => {
  const { t } = useTranslate()
  const orderQuery = useOrderPollingQuery(orderId)
  const cohortQuery = useGroupQuery({
    skip: !cohortId,
    variables: {
      id: cohortId
    }
  })
  const order = orderQuery.data && orderQuery.data.order
  const cohort = cohortQuery.data && cohortQuery.data.group

  useOnOrderFullfiled({
    order,
    onOrderFulfilled
  })

  return cohort ? (
    <>
      {orderQuery.error ? (
        <CenteredContent>
          <Alert error={orderQuery.error} />
        </CenteredContent>
      ) : order && order.order_status === "fulfilled" ? (
        <BlankSlate
          animateIcon
          stack
          icons={null}
          icon="check"
          heading={t("You’re Registered!")}
          body={
            <ul style={{ textAlign: "left", maxWidth: 350 }}>
              <li>{t("You now have 24/7 access to this course")}.</li>
              <li>
                {t(
                  `We've sent you an email receipt with your order information for your records`
                )}
                .
              </li>
            </ul>
          }
          primaryAction={{
            // Hacky method of ensuring we navigate back to the current step
            // if user registered from a step. Better method would be to return
            // to the previous url if url contains "/path/". This will be easier done
            // once s2-inbox is merged which has a simple hook for getting the prev url.
            to: window.App.getStore("step").get("step")
              ? getStepUrl(
                  cohort.resource.slug,
                  cohort.id,
                  window.App.getStore("step").get("step").get("sync_source_id")
                )
              : getGroupUrl(cohort.resource.slug, cohort.id, "path"),
            children: t("Get Started")
          }}
        />
      ) : (
        <BlankSlate
          icons={null}
          heading="Processing order..."
          primaryAction={{
            brand: false,
            submitting: true
          }}
        />
      )}
    </>
  ) : (
    <LoadingCircle />
  )
}

const RegistrationOrderConfirmationCard = ({
  card,
  orderId,
  cohortId,
  onOrderFulfilled
}) => {
  const cohortQuery = useGroupQuery({
    skip: !cohortId,
    variables: {
      id: cohortId
    }
  })
  const cohort = cohortQuery.data && cohortQuery.data.group

  return (
    <NarrowCard card={card} navless>
      {cohort ? (
        <>
          <CardHeader
            card={card}
            resource={cohort.resource}
            title={cohort.resource.name}
            meta={cohort.name}
          />
          <RegistrationOrderConfirmation
            orderId={orderId}
            cohortId={cohortId}
            onOrderFulfilled={onOrderFulfilled}
          />
        </>
      ) : (
        <LoadingCircle />
      )}
    </NarrowCard>
  )
}

export default RegistrationOrderConfirmationCard
